import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-141e397e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }

import BaseButton from '@/components/BaseButton.vue'
import { FORMATS, SIZES } from '@/enums/components'
import { PropType } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import { RouteStop } from '@/models/public/routePlanner.model'
import { formatIntlDateAndTime } from '../../../utils/formatters'
import { OrderItem } from '@/models/public/order.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderItemInfoWindowContent',
  props: {
  routeStops: {
    type: Array as PropType<RouteStop[]>,
    required: true,
  },
},
  setup(__props) {



const getOrderItemQuantity = (orderItem: OrderItem) => {
  return (
    orderItem.experience_data?.group_size ||
    orderItem.ticket_item_data?.quantity ||
    orderItem.visit?.reduce((sum, v) => sum + v.quantity, 0) ||
    orderItem.quantity
  )
}

function handleLinkClick(service: PublicService) {
  window.open(service.public_url, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.routeStops, (routeStop) => {
      return (_openBlock(), _createElementBlock("div", {
        key: routeStop.id,
        class: "service"
      }, [
        _createVNode(BaseButton, {
          label: routeStop.service.name,
          size: _unref(SIZES).SMALL,
          format: _unref(FORMATS).TERTIARY,
          onOnClick: () => handleLinkClick(routeStop.service)
        }, null, 8, ["label", "size", "format", "onOnClick"]),
        _createElementVNode("p", null, _toDisplayString(`Kestvus: ${_unref(formatIntlDateAndTime)(
            routeStop.start_time,
          )} - ${_unref(formatIntlDateAndTime)(routeStop.end_time)}`), 1),
        _createElementVNode("p", null, _toDisplayString(`Grupi suurus/kogus: ${getOrderItemQuantity(routeStop.order_item)}`), 1)
      ]))
    }), 128))
  ]))
}
}

})